import { apiClient } from './client';
import type { EventCategory, Severity, Vendor } from '@ixam/shared';

export interface EventDto {
  _id: string;
  serverId: string;
  vendor: Vendor;
  source: 'webhook' | 'poll' | 'manual';
  severity: Severity;
  category: EventCategory;
  component: string;
  messageId: string | null;
  message: string;
  occurredAt: string;
  receivedAt: string;
  acknowledged: boolean;
  acknowledgedBy: string | null;
  acknowledgedAt: string | null;
  resolved: boolean;
  resolvedAt: string | null;
}

export interface EventFilters {
  page?: number;
  limit?: number;
  serverId?: string;
  severity?: Severity;
  vendor?: Vendor;
  category?: EventCategory;
  from?: string;
  to?: string;
  search?: string;
  resolved?: boolean;
  acknowledged?: boolean;
}

export interface PagedEvents {
  items: EventDto[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export async function listEvents(filters: EventFilters): Promise<PagedEvents> {
  const params: Record<string, string | number | boolean> = {};
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== '' && v !== null) params[k] = v;
  }
  const res = await apiClient.get<PagedEvents>('/events', { params });
  return res.data;
}

export async function acknowledgeEvent(id: string): Promise<EventDto> {
  const res = await apiClient.post<{ event: EventDto }>(`/events/${id}/acknowledge`);
  return res.data.event;
}

export async function resolveEvent(id: string): Promise<EventDto> {
  const res = await apiClient.post<{ event: EventDto }>(`/events/${id}/resolve`);
  return res.data.event;
}

export async function deleteEvent(id: string): Promise<void> {
  await apiClient.delete(`/events/${id}`);
}
